// For using this component use this.showModal('message here');
// This will be open Error Modal.
// If you want to show success model add second parameter as 'success'
// For hiding this modal you can use this.hideModal();

<template>
  <div>
    <b-modal
      class="modal"
      v-model="modal.isActive"
      :id="modalComputed"
      hide-footer
      hide-header
      centered
      @shown="onModalShown"
      @update="onModalUpdate"
    >
      <div class="closeButtonWrapper">
        <button type="button" class="close" @click="closeModal()" :aria-label="$t('closeDialog')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="iconWrapper d-block text-center">
        <template v-if="modal.type != 'custom'">
          <img v-if="modal.type == 'success'" class="icon" src="../assets/icons/success.svg" alt="success" />
          <img v-else class="icon" src="../assets/icons/risk-icon.svg" alt="warning" />
        </template>
      </div>
      <div class="body" ref="body" v-html="modal.message"></div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data () {
    return {};
  },
  methods: {
    onModalShown () {
      this.$nextTick(() => this.enhanceModalContentA11y());
    },
    onModalUpdate () {
      // bootstrap-vue can update modal content while open; keep labels in sync
      if (this.modal?.isActive) {
        this.$nextTick(() => this.enhanceModalContentA11y());
      }
    },
    closeModal () {
      this.hideModal();
    },
    enhanceModalContentA11y () {
      const root = this.$refs.body;
      if (!root) return;

      // Ensure links have descriptive, unique accessible names.
      const links = root.querySelectorAll('a');
      links.forEach((a) => {
        // If dev already provided an accessible name, keep it.
        if (a.hasAttribute('aria-label') || a.hasAttribute('aria-labelledby')) return;

        const rawText = (a.textContent || '').replace(/\s+/g, ' ').trim();
        const href = a.getAttribute('href') || '';

        let destination = href;
        try {
          const url = new URL(href, window.location.href);
          const path = url.pathname && url.pathname !== '/' ? url.pathname : '';
          destination = `${url.hostname}${path}`;
        } catch (e) {
          // keep href as-is for non-standard URLs
        }

        // If visible link text is short/generic (e.g. "her"), append destination.
        // This avoids hardcoding per-language tokens while keeping descriptive names.
        if (rawText && rawText.length < 15 && destination) {
          a.setAttribute('aria-label', `${rawText} (${destination})`);
        } else if (rawText) {
          a.setAttribute('aria-label', rawText);
        } else if (destination) {
          a.setAttribute('aria-label', destination);
        }
      });
    }
  },
  computed: {
    ...mapState({
      modal: state => state.modal
    }),
    modalComputed () {
      return this.modal.type === "custom" ? 'modalCustom' : 'modal'
    }
  }
};
</script>

<style lang="scss">
#modal___BV_modal_content_ {
  border-radius: 0;
  border: unset;
}

#modalCustom___BV_modal_content_ {
  border: 4px solid var(--brand-color-2);
  background-color: beige
}
</style>

<style lang="scss" scoped>
.modal-body {
  display: flex;
  flex-direction: column;
  .closeButtonWrapper {
    position: absolute;
    top: 0;
    right: 0;
    margin: 15px;
  }
  .iconWrapper {
    img {
      height: 80px;
      width: 80px;
    }
    display: flex;
    justify-content: center;
  }
  .body {
    font-family: inherit;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 15px;
  }
}
</style>